import { Component } from "@angular/core";
import {
  AlertController,
  Events,
  IonicPage,
  LoadingController,
  ModalController,
  NavController,
  ToastController,
} from "ionic-angular";
import { Item } from "../../models/item";
import { User } from "../../providers";
import { RequestTermsAcceptedPage } from "../request-terms-accepted/request-terms-accepted";
import { TrainingDetailPage } from "../training-detail/training-detail";

@IonicPage()
@Component({
  selector: "page-list-master",
  templateUrl: "list-master.html",
})
export class ListMasterPage {
  authUser: any;
  title;
  events: any = [];
  waitingEvents: any = [];
  trainings: any = [];
  showBlankState = false;

  constructor(
    public navCtrl: NavController,
    public user: User,
    public toastCtrl: ToastController,
    public modalCtrl: ModalController,
    public alertCtrl: AlertController,
    public loadingCtrl: LoadingController,
    public tabEvents: Events
  ) {
    this.authUser = this.user._user;
  }

  ionViewWillEnter() {
    this.authUser = this.user._user;
    this.refreshEvents(this.authUser);

    // this.title = "Te quedan " + this.authUser.nbSessionsLeft + " clases";
    // if (this.authUser.nbIndividualSessionsLeft) {
    //   this.title =
    //     this.title +
    //     " en grupo y " +
    //     this.authUser.nbIndividualSessionsLeft +
    //     " individuales";
    // }
    if (!this.authUser.termsAcceptedAt) {
      this.requestTermsAccepted();
    }

    this.user.getTrainings("pending").subscribe((result: any) => {
      this.trainings = result.data;
      this.showBlankState = !result.data.length;
      console.log(this.trainings, this.showBlankState);
    });
  }

  handleExerciseClick(trainingId) {
    this.navCtrl.push(TrainingDetailPage, { trainingId });
    this.tabEvents.publish("trainingNavigation", "trainingDetailPage");
  }

  refreshEvents(user) {
    this.events = user.nextEvents.map(function (item) {
      return {
        event: item,
        startsAt: new Date(item.startsAt),
        endsAt: new Date(item.endsAt),
        title: item.name || item.type,
        type: item.type,
        classType: item.classType,
      };
    });
    this.waitingEvents = user.waitingEvents.map(function (item) {
      return {
        event: item,
        startsAt: new Date(item.startsAt),
        endsAt: new Date(item.endsAt),
        title: item.name || item.type,
        type: item.type,
        classType: item.classType,
        badgeColor: item.available ? "success" : "danger",
        badgeLabel: item.available ? "LIBRE" : "LLENA",
        available: item.available,
      };
    });
  }

  doRefresh(event) {
    var self = this;

    self.user.me().subscribe(
      (user) => {
        event.complete();
        this.tabEvents.publish(
          "notifications:updated",
          user.nbUnreadNotifications
        );
        self.refreshEvents(user);
      },
      (err) => {
        event.complete();
        let toast = self.toastCtrl.create({
          message: err.detail
            ? err.detail
            : "Ha ocurrido un error inesperado. Por favor, inténtalo de nuevo más tarde.",
          duration: 3000,
          cssClass: "toast-danger",
          position: "top",
        });
        toast.present();
      }
    );
  }

  /**
   * Delete an item from the list of items.
   */
  deleteItem(item, index) {
    const confirm = this.alertCtrl.create({
      title: "Cancelar clase",
      message: "¿Seguro que quieres cancelar esta clase?",
      buttons: [
        {
          text: "No",
          handler: () => {
            console.log("Disagree clicked");
          },
        },
        {
          text: "Sí",
          handler: () => {
            let loading = this.loadingCtrl.create({
              spinner: "ios",
            });

            loading.present();

            this.user.cancelEvent(item.event.id).subscribe(
              () => {
                this.user.me().subscribe((user) => {
                  this.events = user.nextEvents.map(function (item) {
                    return {
                      event: item,
                      startsAt: new Date(item.startsAt),
                      endsAt: new Date(item.endsAt),
                      title: item.name || item.type,
                      type: item.type,
                      classType: item.classType,
                    };
                  });
                  loading.dismiss();

                  let toast = this.toastCtrl.create({
                    message: "Ok! La clase se ha cancelado correctamente",
                    duration: 2000,
                    cssClass: "toast-success",
                    position: "top",
                  });
                  toast.present();
                });
              },
              (err) => {
                loading.dismiss();
                let toast = this.toastCtrl.create({
                  message: err.detail
                    ? err.detail
                    : "Ha ocurrido un error inesperado. Por favor, inténtalo de nuevo más tarde.",
                  duration: 6000,
                  cssClass: "toast-danger",
                  position: "top",
                });
                toast.present();
              }
            );
          },
        },
      ],
    });
    confirm.present();
  }

  /**
   * Delete an item from the list of items.
   */
  deleteWaitingItem(item, index) {
    const confirm = this.alertCtrl.create({
      title: "Cancelar reserva",
      message:
        "Si cancelas la reserva no te avisaremos cuando quede un hueco libre. ¿Seguro que quieres cancelar esta reserva?",
      buttons: [
        {
          text: "No",
          handler: () => {
            console.log("Disagree clicked");
          },
        },
        {
          text: "Sí",
          handler: () => {
            let loading = this.loadingCtrl.create({
              spinner: "ios",
            });

            loading.present();

            this.user.cancelWaitingEvent(item.event.id).subscribe(() => {
              this.user.me().subscribe(
                (user) => {
                  this.waitingEvents = user.waitingEvents.map(function (item) {
                    return {
                      event: item,
                      startsAt: new Date(item.startsAt),
                      endsAt: new Date(item.endsAt),
                      title: item.name || item.type,
                      type: item.type,
                      classType: item.classType,
                      badgeColor: item.available ? "success" : "danger",
                      badgeLabel: item.available ? "LIBRE" : "LLENA",
                      status: item.status,
                    };
                  });
                  loading.dismiss();

                  let toast = this.toastCtrl.create({
                    message: "Ok! La reserva se ha cancelado correctamente",
                    duration: 2000,
                    cssClass: "toast-success",
                    position: "top",
                  });
                  toast.present();
                },
                (err) => {
                  loading.dismiss();
                  let toast = this.toastCtrl.create({
                    message: err.detail
                      ? err.detail
                      : "Ha ocurrido un error inesperado. Por favor, inténtalo de nuevo más tarde.",
                    duration: 6000,
                    cssClass: "toast-danger",
                    position: "top",
                  });
                  toast.present();
                }
              );
            });
          },
        },
      ],
    });
    confirm.present();
  }

  joinWaitingItem(calEvent, index) {
    let self = this;
    const startDate = calEvent.startsAt
      .toLocaleTimeString("pt-PT")
      .substr(0, 5);
    const confirm = self.alertCtrl.create({
      title: "Reservar clase",
      message: "¿Quieres apuntarte a la clase de las " + startDate + "?",
      buttons: [
        {
          text: "Cancelar",
          handler: () => {
            console.log("Disagree clicked");
          },
        },

        {
          text: "Apuntarme",
          handler: () => {
            let loading = self.loadingCtrl.create({
              spinner: "ios",
            });

            loading.present();

            self.user.joinEvent(calEvent.event.id).subscribe(
              (resp) => {
                self.user.me().subscribe((user) => {
                  loading.dismiss();
                  self.refreshEvents(user);

                  let toast = self.toastCtrl.create({
                    message: "Perfecto! Ya estás apuntado a la clase",
                    duration: 2000,
                    cssClass: "toast-success",
                    position: "top",
                  });
                  toast.present();
                });
              },
              (err) => {
                self.user.me().subscribe(
                  (user) => {
                    loading.dismiss();
                    self.refreshEvents(user);

                    let toast = self.toastCtrl.create({
                      message: err.detail
                        ? err.detail
                        : "Ha ocurrido un error inesperado. Por favor, inténtalo de nuevo más tarde.",
                      duration: 3000,
                      cssClass: "toast-danger",
                      position: "top",
                    });
                    toast.present();
                  },
                  (err) => {
                    loading.dismiss();
                    let toast = self.toastCtrl.create({
                      message: err.detail
                        ? err.detail
                        : "Ha ocurrido un error inesperado. Por favor, inténtalo de nuevo más tarde.",
                      duration: 3000,
                      cssClass: "toast-danger",
                      position: "top",
                    });
                    toast.present();
                  }
                );
              }
            );
          },
        },
      ],
    });
    confirm.present();
  }

  /**
   * Navigate to the detail page for this item.
   */
  openItem(item: Item) {
    this.navCtrl.push("ItemDetailPage", {
      item: item,
    });
  }

  showInfo() {
    let toast = this.toastCtrl.create({
      message:
        "Desplaza el dedo hacia la izquierda sobre cada una de las clases para poder cancelar la clase. Si lo haces sobre las clases de la lista de espera, podrás cancelar la reserva o apuntarte a la clase si te avisamos de que queda un hueco libre. ",
      showCloseButton: true,
      closeButtonText: "Ok",
      position: "top",
    });
    toast.present();
  }

  requestTermsAccepted() {
    let modal = this.modalCtrl.create(RequestTermsAcceptedPage, {
      content: this.authUser.terms,
    });
    modal.present();
    modal.onDidDismiss(() => {
      let toast = this.toastCtrl.create({
        message: "Gracias por colaborar!",
        duration: 3000,
        cssClass: "toast-success",
        position: "top",
      });
      toast.present();
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/list-master/list-master.ts